export { default } from './SingleAnswerV2QuizStep';
